import React from 'react';
export default function AuthCard({ children, className = '' }) {
  return (
    <div
      className={`w-full max-w-[512px] px-10 md:px-16 rounded-md border border-slate-100 bg-white/95 p-6 shadow-[0_8px_40px_rgba(10,10,10,0.06)] ${className}`}
    >
      {children}
    </div>
  );
}

